import React, { FC, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import axiosApiInstance from 'src/api/axiosConfig';
import { palette } from 'src/Theme';
import ShsSelectInput from 'src/components/common/Fields/ShsSelectInput';
import { useScheduleCalendarContext } from '../../common/context/CalendarContext';
import { EducationCenterType, Hospital } from 'src/components/Employees/types';
import { useFormContext } from 'react-hook-form';

const fetchEducationCenters = async (): Promise<any> => {
    const { data } = await axiosApiInstance.get(`centers`);

    return data;
};

const fetchSelectedCenter = async (id: string): Promise<EducationCenterType> => {
    const { data } = await axiosApiInstance.get(`centers/${id}`);

    return data;
};

export const ScheduleEducationCenters: FC = () => {
    const [eduCenters, setEduCenters] = useState<EducationCenterType[]>([]);
    const [hospitals, setHospitals] = useState<Array<{ id: string | number; name: string }>>([]);
    const { calendarData, setCalendarData } = useScheduleCalendarContext();
    const { setValue } = useFormContext();

    useEffect(() => {
        fetchEducationCenters().then((data) => {
            const centers = data
                .filter((x: EducationCenterType) => x.active)
                .map((centr: any) => ({ id: centr.id, name: centr.shortName }));
            setEduCenters(centers);
        });
    }, [setEduCenters]);

    const handleCenterChange = async (e: any) => {
        const id = e?.target?.value?.toString();
        const center = await fetchSelectedCenter(id);

        setCalendarData((value) => ({ ...value, educationCenter: center }));

        const choices = (center?.hospitals || []).map((hospital: Hospital, idx: number) => ({
            id: hospital.id ?? idx,
            name: hospital.name
        }));
        setHospitals(choices);

        if (center?.hospitals?.length === 1) {
            const only = center?.hospitals[0];
            setCalendarData((value) => ({ ...value, hospital: only }));
            setValue('hospital', only?.id);
        } else {
            setCalendarData((value) => ({ ...value, hospital: undefined }));
        }
    };

    const handleHospitalChange = (e: any) => {
        const id = e?.target?.value;
        const sel = calendarData.educationCenter?.hospitals.find((h) => String(h.id) === String(id));
        setCalendarData((value) => ({ ...value, hospital: sel }));
    };

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    gap: '20px',
                    marginRight: '20px',
                    '& .text_field__label': {
                        fontWeight: 400,
                        fontSize: '11px',
                        lineHeight: '14px',
                        color: palette.primary.grayBluish
                    }
                }}>
                <ShsSelectInput
                    sx={{
                        width: '280px',

                        '.MuiInputBase-root': {
                            height: '40px',
                            fontSize: '14px',
                            '.MuiInputBase-input': {
                                display: 'flex',
                                alignItems: 'center',
                                height: '40px',
                                paddingBottom: 0,
                                paddingTop: 0
                            }
                        }
                    }}
                    source="center"
                    label="Освітній центр"
                    choices={eduCenters}
                    onChange={handleCenterChange}
                    filter=""
                    autoFocus
                    required
                />
                <ShsSelectInput
                    sx={{
                        width: '280px',
                        '.MuiInputBase-root': {
                            height: '40px',
                            fontSize: '14px',
                            '.MuiInputBase-input': {
                                display: 'flex',
                                alignItems: 'center',
                                height: '40px',
                                paddingBottom: 0,
                                paddingTop: 0
                            }
                        }
                    }}
                    disabled={!calendarData.educationCenter}
                    source="hospital"
                    label="Лікарня"
                    choices={hospitals}
                    onChange={handleHospitalChange}
                    filter=""
                    autoFocus
                    required
                />
            </Box>
        </>
    );
};
